import { logger } from './logger';

const ua = navigator.userAgent.toLowerCase();
const safariUserAgent = ua.indexOf('safari') >= 0 && ua.indexOf('chrome') === -1;

logger.log('is safari ua', safariUserAgent);

export const isSafari = !!(window as any).safari || safariUserAgent;

const uA = navigator.userAgent;
const vendor = navigator.vendor;
export const isSafariDesktop =
    (/Safari/i.test(uA) && /Apple Computer/.test(vendor) && !/Mobi|Android/i.test(uA));

logger.log('is safari', isSafari);

export const supportsCssVars =
  (window as any).CSS &&
  (window as any).CSS.supports &&
  (window as any).CSS.supports('--fake-var', 0);

export const supportsObjectFit =
  (window as any).CSS &&
  (window as any).CSS.supports &&
  (window as any).CSS.supports('object-fit', 'contain');
